import React from 'react';
import { Tooltip } from '../CommonComponents/OPL/Tooltip/Tooltip';

export default ({ detail, even }) => {
  return (
    <li className={`detail indented${even ? ' even' : ''}`}>
      <div>
        {detail.name ? (
          <Tooltip content={detail.name} placement="top-start" offset={[50, -4]}>
            <span>{detail.name}</span>
          </Tooltip>
        ) : (
          <span> </span>
        )}
      </div>
    </li>
  );
};
